export const valueOrUndefined = <T>(value: T) => value ?? undefined;
export const valueOrNull = <T>(value: T) => value ?? null;
